// C4 — per-user first-run coachmark state.
//
// Persisted via the EXISTING generic per-user store
// (useViewPreference → /api/view-preferences → user_view_preferences,
// already in production). No new table, no migration, no KV, no
// localStorage (CLAUDE.md bans localStorage in prod). surface_key =
// "cleanup-coachmarks".
//
// Pure + root-safe (imports nothing) so the parser is stable across
// renders (useViewPreference requires a stable `parse`) and is
// unit-tested without pulling in ../api — exactly the pattern
// zone-layout.ts uses for the same reason.

export interface CoachmarkState {
  // The dismissible 3-step coachmark on first /cleanup workspace open.
  workspaceSeen?: boolean;
  // The dismissible coachmark on first in-record Cleanup drawer open.
  drawerSeen?: boolean;
}

// Baseline = nothing seen yet (a brand-new user sees both once).
export const COACHMARK_BASELINE: CoachmarkState = {};

export const COACHMARK_SURFACE_KEY = "cleanup-coachmarks";

// Tolerant parse: unknown / malformed → null (the hook then falls
// back to baseline). Only the two known booleans are carried through;
// any extra keys are dropped so a future shape can't leak stale data.
export function parseCoachmarkState(json: string): CoachmarkState | null {
  let raw: unknown;
  try {
    raw = JSON.parse(json);
  } catch {
    return null;
  }
  if (raw === null || typeof raw !== "object" || Array.isArray(raw)) {
    return null;
  }
  const o = raw as Record<string, unknown>;
  const out: CoachmarkState = {};
  if (typeof o.workspaceSeen === "boolean") {
    out.workspaceSeen = o.workspaceSeen;
  }
  if (typeof o.drawerSeen === "boolean") {
    out.drawerSeen = o.drawerSeen;
  }
  return out;
}
